import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { withLocalize } from 'react-localize-redux';
import { renderToStaticMarkup } from 'react-dom/server';
/**
 * Import translations
 */
import General from 'translations/general.json';
import Portfolio from 'translations/components/portfolio.json';
import Scan from 'translations/components/scan.json';
import User from 'translations/components/user.json';
import Project from 'translations/components/project.json';
import Work from 'translations/components/work.json';
import Course from 'translations/components/course.json';
import Dream from 'translations/components/dream.json';
import Reflection from 'translations/components/reflection.json';
import Filters from 'translations/components/filters.json';
import NoContent from 'translations/components/nocontent.json';

const mapStateToProps = (state) => ({
  language: state.authentication.user && state.authentication.user.language,
});

class Localize extends Component {
  constructor(props) {
    super(props);

    // add translations here
    this.props.addTranslation({
      user: User,
      general: General,
      scan: Scan,
      project: Project,
      work: Work,
      course: Course,
      dream: Dream,
      reflection: Reflection,
      filters: Filters,
      portfolio: Portfolio,
      nocontent: NoContent,
    });
  }

  componentDidMount() {
    this.props.initialize({
      languages: [
        { name: 'Nederlands', code: 'nl' },
        { name: 'English', code: 'en' },
      ],
      options: {
        renderToStaticMarkup,
        defaultLanguage: this.props.language || 'nl',
        onMissingTranslation: ({ translationId }) =>
          console.error(
            `Missing or incorrect translation ID: ${translationId}`
          ),
      },
    });
  }

  componentDidUpdate(prevProps) {
    if (
      (!prevProps.language && this.props.language) ||
      (prevProps.language !== this.props.language && this.props.language)
    ) {
      this.props.setActiveLanguage(this.props.language);
    }
  }

  render() {
    return <>{this.props.children}</>;
  }
}

export default withLocalize(connect(mapStateToProps)(Localize));
